module.exports = __webpack_public_path__ + "static/media/vin_certificate.17e1b897.jpg";